import React from 'react';
import { FilePreviewFileInfo } from '../types';

function ImagePreview(props: { value: FilePreviewFileInfo }) {
  const { value } = props;

  return (
    <div className="asset-management-file-preview-image-content">
      <img src={value.url} alt={value.name} />
    </div>
  );
}

export default ImagePreview;
